import React, { useCallback, useEffect, useState, useMemo } from "react"
import { AddNumberConfig } from "../../components/AddNumberConfig"
import { storage } from "../../core/firebase"
import Send from "../../core/communication"

const AddNumberConfigContainer = ({ project = {}, modalIsOpen, handleCloseModal }) => {
  const [loading, setLoading] = useState(false)
  const [shouldRefetch, setShouldRefetch] = useState(false)
  const [qrcode, setQRCode] = useState(null)
  const [successQR, setSuccessQR] = useState(null)

  const fetchQrCodes = useCallback(async () => {
    if (!project?.name) return

    setLoading(true)
    try {
      const data = await Send.post('/evolution-api/instance-status', {
        instanceName: project?.name
      })

      if (data?.qrcode) {
        setQRCode(data?.qrcode)
      } else if (data?.status === 'connected') {
        setSuccessQR(true)
      }

    } catch (error) {
      console.error("Erro ao buscar QR codes:", error)
    } finally {
      setLoading(false)
    }
  }, [project?.name])

  useEffect(() => {
    if (modalIsOpen) {
      fetchQrCodes()
    }
  }, [modalIsOpen, fetchQrCodes])

  useEffect(() => {
    if (shouldRefetch) {
      fetchQrCodes()
      setShouldRefetch(false)
    }
  }, [shouldRefetch, fetchQrCodes])

  const handleCloseAllModals = () => {
    handleCloseModal()
  }

  const handleGenerateQRCode = async () => {
    setLoading(true)

    try {
      const data = await Send.post('/evolution-api/create-instance', {
        instanceName: project?.name
      })

      if (data?.qrcode) {
        setQRCode(data?.qrcode)
      }
    } catch (error) {
      console.error("Erro ao gerar QR code:", error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <AddNumberConfig
      project={project}
      modalIsOpen={modalIsOpen}
      handleCloseModal={handleCloseAllModals}
      handleGenerateQRCode={handleGenerateQRCode}
      loading={loading}
      qrcode={qrcode}
      successQR={successQR}
    />
  )
}

export default AddNumberConfigContainer
